import "./Button.scss";

import { Component, h, render } from "preact";

export function Button({ children, type, disabled = false, ...rest }) {
  return (
    <button
      type={type}
      disabled={disabled}
      className="CCButton t-text"
      {...rest}
    >
      {children}
    </button>
  );
}
